/**
 * 定义数据字典
 */
import cookie from 'js-cookie';
import Vue from "vue";
import VueI18n from 'vue-i18n';
Vue.use(VueI18n);
const i18n = {
    locale: cookie.get('mfs_lang') || 'zh', // 语言标识,第一次登录默认是中文
    messages: {
        zh: require('@/locales/zh-cn'), // 汉语
        en: require('@/locales/en_us'), // 英语
    }
}
let str = ''
for (let i = 0, locale = i18n.locale; i < locale.length; i++) {
    if(i<2) str = `${str}${locale[i]}`
}
// 用户管理 模块
export const users = {
    // 用户类型
    userType: {
        0: i18n.messages[str].language['5o6u3frcn6k0'],
        1: i18n.messages[str].language['5o6u3frcn7k0']
    },
    userStatus: {
        0: i18n.messages[str].language['5o6trh9vmrs0'],
        1: i18n.messages[str].language['5o6trh9vmow0']
    },
    userSystemType: {
        1: i18n.messages[str].language['5o6v4bolg4w2'],
        2: i18n.messages[str].language['5o6v4bo1g4w1'],
        3: i18n.messages[str].language['5o6v4bolg4wm'],
        5: i18n.messages[str].language['5o6v4bolg4s1'],
        6: i18n.messages[str].language['5o6v4bowg4w1']
    },
};
